import oidcService from '../oidc/service';
import { useDispatch } from 'react-redux';
import { userSignedIn, userSignedOut } from '../ducks/app';
import { useUserStore } from '../stores/user';

export const useOidc = () => {
  const { user, setUser, silentAttempted } = useUserStore();
  const dispatch = useDispatch();

  const login = async () => {
    if (!oidcService.isValid()) return;
    await oidcService.login();
    const user = await oidcService.getUser();
    setUser(user);
    dispatch(userSignedIn(user.access_token, user));
  };

  const logout = async () => {
    if (!oidcService.isValid()) return;
    await oidcService.logout();
    setUser(null);
    dispatch(userSignedOut());
  };

  return {
    user,
    setUser,
    silentAttempted,
    access_token: user?.access_token,
    isAuthenticated: user && !user.expired,
    login,
    logout,
    hasAuth: oidcService.isValid(),
  };
};
